<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
    :class="{ hideButton: hideConfig }"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :rules="editFormRules"
      >
      <!-- <el-form-item label="捐赠项目：" prop="ProjectName">
          <el-input
            v-model="dataForm.ProjectName"
            clearable
            placeholder="请输入捐赠项目"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="捐赠项目：" prop="ProjectName">
          <el-select
            style="width:100%"
            placeholder="请选择"
            v-model="dataForm.ProjectName"
            allow-create filterable
          >
            <el-option
              v-for="item in projectNameOptions"
              :key="item.ProjectCode"
              :label="item.ProjectName"
              :value="item.ProjectName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="捐赠者：" prop="Name">
          <el-input
            v-model="dataForm.Name"
            clearable
            placeholder="请输入捐赠者"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话号码：">
          <el-input
            v-model="dataForm.Phone"
            clearable
            placeholder="请输入电话号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="捐赠方式：" prop="PayType">
          <el-select v-model="dataForm.PayType" placeholder="请选择">
            <el-option
              v-for="item in payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="汇款凭证码："
          prop="ReceiptNo"
          v-if="dataForm.PayType == 3"
        >
          <el-input
            v-model="dataForm.ReceiptNo"
            clearable
            placeholder="请输入汇款凭证码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="付款凭证："
          prop="File"
          v-if="dataForm.PayType == 3"
        >
          <p>支持png/jpg/jpeg格式，建议尺寸650*360</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            :fileList="pictureList"
            :class="{ hideFile: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item label="捐赠金额：" prop="Amount" style="width: 7rem">
          <el-input
            v-model="dataForm.Amount"
            clearable
            placeholder="请输入捐赠金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="捐赠者类型：" prop="Donation">
          <el-select placeholder="请选择" v-model="dataForm.Donation">
            <el-option
              v-for="item in donatorTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="捐款时间：" prop="FinishTime">
          <el-date-picker
            v-model="dataForm.FinishTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否开票：" prop="IsInvoice">
          <el-select placeholder="请选择" v-model="dataForm.IsInvoice">
            <el-option
              v-for="item in isInvoiceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="捐赠留言：" prop="Remark">
          <el-input
            v-model="dataForm.Remark"
            clearable
            placeholder="请输入捐赠留言"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (!/^1[0-9]{10}$/.test(value)) {
        return callback(new Error("无效手机号码"));
      }
      callback();
    };
    //金额校验
    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入捐款金额"));
      }
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          value
        )
      ) {
        return callback(new Error("无效捐款金额，请保留两位小数"));
      }
      callback();
    };
    return {
      editFormRules: {
        Donation: {
          required: true,
          message: "请选择捐赠者类型",
          trigger: "blur",
        },
        Name: [
          {
            required: true,
            message: "请输入捐赠者名称",
            trigger: "blur",
          },
          { max: 30, message: "长度在30个字符以内", trigger: "blur" },
        ],
        Phone: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur",
        },
        ProjectName: {
          required: true,
          message: "请输入项目名称",
          trigger: "blur",
        },
        PayType: {
          required: true,
          message: "请选择捐款方式",
          trigger: "blur",
        },
        Amount: {
          required: true,
          validator: checkAmount,
          trigger: "blur",
        },
        ReceiptNo: {
          required: true,
          message: "请输入回执单号",
          trigger: "blur",
        },
        IsInvoice: {
          required: true,
          message: "请选择是否需要开具票据",
          trigger: "blur",
        },
        FinishTime: {
          required: true,
          message: "请选择捐赠时间",
          trigger: "blur",
        },
        File: {
          required: true,
          message: "请上传付款凭证",
          trigger: "blur",
        },
      },
      isConfirm: false,
      ishide: false,
      activeValue: 1,
      inactiveValue: 0,
      hideConfig: false,
      payTypeOptions: [
        { value: 1, label: "在线银联" },
        { value: 2, label: "手机支付" },
        { value: 3, label: "线下转账" },
      ],
      donatorTypeOptions: [
        { value: 1, label: "个人" },
        { value: 2, label: "企业" },
      ],
      isInvoiceOptions: [
        { value: false, label: "否" },
        { value: true, label: "是" },
      ],
      projectNameOptions: [],
      width: "40%",
      pictureList: [],
      hideUploadEdit: false,
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  computed: {
    //是否开具发票
    isInvoice: function () {
      return this.dataForm.IsInvoice ? 1 : 0;
    },
  },
  mounted() {
    this.getImg();
    this.getProjectNameOptions();
  },
  created() {
    ///支付方式
    // switch (this.dataForm.PayType) {
    //   case 1:
    //     this.isx = false;
    //     break;
    //   case 2:
    //     this.isz = false;
    //     break;
    //   case 3:
    //     this.isw = false;
    //     break;
    // }
  },
  components: {
    OfDialog,
    OfUpload,
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //新增
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.Status = 1;
          params.FinishTime = params.FinishTime / 1000;
          params.CreateTime = 0;
          params.IsSystem = true;
          api
            .SaveContriBution(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //获取项目信息
    getProjectNameOptions() {
      api.QueryPublicWelfareAll().then((rep) => {
        if (rep.data.Code === 0) {
          this.projectNameOptions = rep.data.Data;
        }
      });
    },
    //删除封面图
    onRemove() {
      this.pictureList = [];
      this.dataForm.CoverMap = null;
      this.hideUploadEdit = false;
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传封面图
    onUpLoad(file) {
      if (file.response.Code === 0) {
        this.dataForm.File = file.response.Data.FileId;
        this.$message({
          message: "封面图上传成功",
          type: "success",
        });
        this.hideUploadEdit = true;
        debugger;
      }
    },
    selectOne(val) {
      const { value, label } = val
      this.dataForm.ProjectId = value;
      this.dataForm.ProjectName = label;
    },
    //初始化封面图
    getImg() {
      if (
        this.dataForm.File === undefined ||
        this.dataForm.File === null ||
        this.dataForm.File == ""
      ) {
        return;
      }
      this.hideUploadEdit = true;
      this.$http
        .get("/Sys/File/Download?Id=" + this.dataForm.File)
        .then((res) => {
          let pictureList = [res.config];
          this.pictureList = pictureList.map((item) => {
            return {
              url: item.url,
            };
          });
        });
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.hideFile >>> .el-upload--picture-card {
  display: none !important;
}
</style>

<style>
.hideButton .dialog-footer >>> .el-button--primary {
  display: none;
}
</style>
